import { Component, signal } from '@angular/core';

import { RouterLink } from '@angular/router';
import { AuiIconComponent } from '@ral/ui:aui/icons';
import { StoryCardComponent } from '@storyteller/card';
import { StoryContainerComponent } from '@storyteller/container';
import { StoryDescriptionComponent } from '@storyteller/description';
import { StoryFeatureComponent } from '@storyteller/feature';
import { StoryImageComponent, StoryImageSourceComponent } from '@storyteller/image';
import { StoryTitleComponent } from '@storyteller/title';
import { EasyLeanKitComponent } from '../components';
import { AcpSystemComponent } from '../components/acp-system.component';
import { AntBotCncComponent } from '../components/antbot-pro-cnc.component';
import { InquiryComponent, InquiryItemComponent } from '../components/inquiry.component';
import { AppSimplyCarouselComponent } from '../components/simply-carousel.component';
import { AuiItemComponent } from '@ral/ui:aui/item';
@Component({
    selector: 'app-mill-bar-feeder-page',
    imports: [
        StoryContainerComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        StoryImageComponent,
        AuiItemComponent,
        InquiryComponent,
        EasyLeanKitComponent,
        AntBotCncComponent,
        AcpSystemComponent,
        AcpSystemComponent,
        StoryFeatureComponent,
        InquiryItemComponent,
        AuiIconComponent,
        RouterLink,
        StoryImageSourceComponent,
        AppSimplyCarouselComponent,
        StoryCardComponent,
    ],
    template: `
        <header>
            <story-container
                [space]="'py-[20px] w500:py-[40px] md:py-[70px] lg:py-[100px]'"
                [skipTopPadding]="true"
                [skipSmallScreenTopPadding]="true"
            >
                <div class="detail-cover gap-6 md:gap-10">
                    <div class="img-block">
                        <story-image
                            fetchPriority="high"
                            [loading]="'eager'"
                            class="block aspect-[345/435] max-w-[500px] overflow-hidden rounded sm:aspect-[500/600]"
                            aria-labelledby="mill-bar-feeder-title"
                        >
                            <story-source
                                [src]="'assets/images/mill-bar-feeder.jpg'"
                                [width]="500"
                                [height]="600"
                                media="(min-width: 640px)"
                            />
                            <story-source
                                [src]="'assets/images/mill-bar-feeder.jpg'"
                                [width]="500"
                                [height]="600"
                                media="(min-width: 200px)"
                            />
                        </story-image>
                    </div>

                    <div class="title-block">
                        <div class="flex flex-col gap-2" id="mill-bar-feeder-title">
                            <story-title [headingLevel]="1" className="story-font-headline1 pb-3 w500:pb-4"
                                >Mill bar feeder</story-title
                            >
                            <story-description>
                                Silové sklíčidlo a&nbsp;gripper mění vaši čtvrtou osu v&nbsp;automatizovaný systém.
                            </story-description>
                        </div>
                        <div class="flex flex-col gap-1 pb-[11px] pt-6 w460:flex-row md:gap-2 md:pt-8">
                            <div>
                                <button auiItem [size]="'40'" [color]="'primary'" (click)="openInquiryForm()">
                                    <span auiItemLabel>Zobrazit cenu</span>
                                </button>
                            </div>
                            <a auiItem [size]="'40'" [color]="'gray'" auiStyle="decent" [routerLink]="['/', 'mill-bar-feeder']" fragment="description">
                                <span auiItemLabel>Chci více informací</span>
                            </a>
                            <!-- <div>
                                <aui-button
                                    [size]="'40'"
                                    label="Ke stažení"
                                    [color]="'primary'"
                                    [buttonStyle]="'text'"
                                ></aui-button>
                            </div> -->
                        </div>
                    </div>
                    <div class="features-block self-end">
                        <div class="w500:grid-cols-2 grid grid-cols-1 gap-5 lg:gap-10">
                            <div>
                                <story-feature>
                                    <aui-icon icon="clipboard-clock" class="text-[28px]" />
                                    <story-title [headingLevel]="2" className="story-font-headline3 pb-1"
                                        >Dlouhý výrobní cyklus</story-title
                                    >
                                    <story-description>
                                        Průchozí sklíčidlo zajišťuje dlouhý výrobní cyklus bez obsluhy a&nbsp;se
                                        stabilní a&nbsp;přesnou sílou upnutí.
                                    </story-description>
                                </story-feature>
                            </div>
                            <div>
                                <story-feature>
                                    <aui-icon icon="flux-capacitor" class="text-[28px]" />
                                    <story-title [headingLevel]="2" className="story-font-headline3 pb-1"
                                        >Štíhlá výroba</story-title
                                    >
                                    <story-description>
                                        Integrované sklíčidlo a&nbsp;gripper. Bez dalších ochran a&nbsp;bez extra
                                        zástavby.
                                    </story-description>
                                </story-feature>
                            </div>
                        </div>
                    </div>
                </div>
            </story-container>
        </header>
        <section>
            <div class="-top:5 w500:-top-12 relative">
                <div id="description" class="relative -top-12 lg:top-[-100px]"></div>
            </div>
            <story-container [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <div class="flex flex-col-reverse items-center gap-5 md:grid md:grid-cols-2 lg:gap-10">
                    <div>
                        <story-title [headingLevel]="2" className="story-font-headline2 pb-6"
                            >Produktový popis</story-title
                        >
                        <story-description class="block">
                            Mill Bar Feeder probudí skrytou sílu vaší frézky se čtvrtou osou. Průchozí sklíčidlo
                            a&nbsp;přesná síla upnutí zajišťují kvalitu, automatické podávání materiálu drží rytmus
                            a&nbsp;stroj běží dlouhé cykly bez zásahu obsluhy.
                            <br /><br />

                            Řízení probíhá přímo ve stroji, takže zůstává zachována bezpečnost a&nbsp;přehlednost bez
                            další zástavby. Rychlé upínání, široký rozsah čelistí a nízké prostoje zkracují čas
                            a&nbsp;zvyšují počet vyrobených kusů během každé směny. Jedno spuštění zvládne desítky dílů,
                            operátor ušetří kroky i&nbsp;námahu a&nbsp;vaše kapacita naroste bez složitých úprav.
                        </story-description>
                    </div>
                    <div>
                        <story-image class="block aspect-[661/392]">
                            <story-source [src]="'assets/images/mill-bar-feeder.png'" [width]="661" [height]="392" />
                        </story-image>
                    </div>
                </div>
            </story-container>
        </section>

        <section class="overflow-hidden">
            <story-container [space]="'w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <app-carousel
                    [slides]="[
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0147.JPG',
                            isPortrait: false,
                            alt: 'Mill Bar Feeder | Fotka 1',
                        },
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0210.JPG',
                            isPortrait: false,
                            alt: 'Mill Bar Feeder | Fotka 2',
                        },
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0137.JPG',
                            isPortrait: true,
                            alt: 'Mill Bar Feeder | Fotka 3',
                        },
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0211.JPG',
                            isPortrait: false,
                            alt: 'Mill Bar Feeder | Fotka 4',
                        },
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0219.JPG',
                            isPortrait: false,
                            alt: 'Mill Bar Feeder | Fotka 5',
                        },
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0206.JPG',
                            isPortrait: false,
                            alt: 'Mill Bar Feeder | Fotka 6',
                        },
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0148.JPG',
                            isPortrait: false,
                            alt: 'Mill Bar Feeder | Fotka 7',
                        },
                        {
                            url: 'assets/images/mill-bar-feeder/FM1A0139.JPG',
                            isPortrait: false,
                            alt: 'Mill Bar Feeder | Fotka 8',
                        },
                    ]"
                ></app-carousel>
            </story-container>
        </section>

        <section>
            <story-container [space]="'pt-12 w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <story-title [headingLevel]="3" className="story-font-headline2 pb-6 md:pb-7 lg:pb-8"
                    >Technické specifikace</story-title
                >
                <table class="w-full table-fixed text-left">
                    <thead>
                        <tr>
                            <th class="pb-2 pt-6 font-semibold">Parametr</th>
                            <th aria-label="Hodnota"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tr">
                            <th>Rozsah průměru tyče</th>
                            <td>Ø9 - Ø44,3&nbsp;mm</td>
                        </tr>
                        <tr class="tr">
                            <th>Max. délka tyče</th>
                            <td>podle umístění ve stroji</td>
                        </tr>

                        <tr class="tr">
                            <th>Průchozí sklíčidlo</th>
                            <td>ano</td>
                        </tr>
                        <tr class="tr">
                            <th>Síla upnutí</th>
                            <td>15&nbsp;kN</td>
                        </tr>
                        <tr class="tr">
                            <th>Způsob podání</th>
                            <td>Schunk gripper synchronizace s&nbsp;CNC</td>
                        </tr>
                        <tr class="tr">
                            <th>Zbytková délka</th>
                            <td>40&nbsp;mm</td>
                        </tr>
                        <tr class="tr">
                            <th>Čas výměny tyče</th>
                            <td>60&nbsp;s</td>
                        </tr>
                        <tr class="tr">
                            <th>Potřeba externí zástavby</th>
                            <td>ne</td>
                        </tr>
                        <tr class="tr">
                            <th>Programování</th>
                            <td>v&nbsp;řídicím systému stroje</td>
                        </tr>
                        <tr class="tr">
                            <th>Požadavky na stroj</th>
                            <td>Hass HRT 210, vnitří chlazení vřetenem</td>
                        </tr>
                        <tr class="tr">
                            <th>Provozní tlak vzhuchu</th>
                            <td>2 - 5&nbsp;bar</td>
                        </tr>
                    </tbody>
                </table>
                <h4 class="pb-2 pt-6 font-semibold">Technický popis</h4>

                <story-description class="block max-w-[640px]">
                    Uchopovač Schunk je určen pro upnutí do Weldon držáku. Silové sklíčidlo je řízeno pneumatickým
                    okruhem, který umožňuje přesné a opakovatelné upnutí.
                </story-description>
            </story-container>
        </section>
        <section>
            <story-container [space]="'pt-12 w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <story-title [headingLevel]="3" className="story-font-headline2 pb-6 md:pb-7 lg:pb-8"
                    >Ke stažení</story-title
                >
                <div class="flex flex-wrap gap-6 lg:gap-8">
                    <div class="min-w-[245px] max-w-[320px] flex-grow">
                        <story-card>
                            <aui-icon icon="file-pdf" class="text-[32px]" />
                            <story-title [headingLevel]="4" className="@lg:story-font-headline4 story-font-headline4"
                                >Technická specifikace</story-title
                            >
                            <story-description
                                [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-14 leading-[1.5]'"
                            >
                                Tento soubor obsahuje rozměry a technické specifikace pro Mill Bar Feeder.
                            </story-description>
                            <a
                                auiItem
                                [size]="'40'"
                                [color]="'primary'"
                                [auiStyle]="'decent'"
                                [fullWidth]="true"
                                [href]="'/assets/files/mill-bar-feeder_tech-spec.pdf'"
                                download
                                aria-label="Stáhnout specifikaci (PDF, méně než 1 MB)"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span auiItemLabel>Stáhnout specifikaci</span>
                            </a>
                        </story-card>
                    </div>
                    <div class="min-w-[245px] max-w-[320px] flex-grow">
                        <story-card>
                            <aui-icon icon="file-pdf" class="text-[32px]" />
                            <story-title [headingLevel]="4" className="@lg:story-font-headline4 story-font-headline4"
                                >Technický výkres</story-title
                            >
                            <story-description
                                [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-14 leading-[1.5]'"
                            >
                                Tento soubor obsahuje technický výkres pro Mill Bar Feeder.
                            </story-description>
                            <a
                                auiItem
                                [size]="'40'"
                                [color]="'primary'"
                                [auiStyle]="'decent'"
                                [fullWidth]="true"
                                [href]="'/assets/files/mill-bar-feeder_tech-vykres.pdf'"
                                download
                                aria-label="Stáhnout výkres (PDF, méně než 1 MB)"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span auiItemLabel>Stáhnout výkres</span>
                            </a>
                        </story-card>
                    </div>
                </div>
            </story-container>
        </section>

        <section>
            <story-container>
                <story-title [headingLevel]="2" className="story-font-headline1 pb-12 md:pb-16 lg:pb-20"
                    >Prohlédněte si ostatní produkty</story-title
                >

                <div class="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
                    <div>
                        <app-easy-lean-kit></app-easy-lean-kit>
                    </div>

                    <div>
                        <app-antbot-pro-cnc></app-antbot-pro-cnc>
                    </div>

                    <div>
                        <app-acp-system></app-acp-system>
                    </div>
                </div>
            </story-container>
        </section>
        @if (isInquiryFormOpened()) {
            <app-inquiry-form (closeInquiry)="closeInquiryForm()" [productName]="'Mill bar feeder'">
                <app-inquiry-item productName="Mill bar feeder" [priceWithoutVat]="215000"></app-inquiry-item>
            </app-inquiry-form>
        }
    `,
})
export class MillBarFeederPageComponent {
    isInquiryFormOpened = signal<boolean>(false);

    openInquiryForm() {
        this.isInquiryFormOpened.set(true);
    }

    closeInquiryForm() {
        this.isInquiryFormOpened.set(false);
    }
}
